import { render, staticRenderFns } from "./StatisicsLine.vue?vue&type=template&id=99652050&scoped=true"
import script from "./StatisicsLine.vue?vue&type=script&lang=js"
export * from "./StatisicsLine.vue?vue&type=script&lang=js"
import style0 from "./StatisicsLine.vue?vue&type=style&index=0&id=99652050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99652050",
  null
  
)

export default component.exports